
export default [
  '$window',
  UnAuthedInterceptor,
];

export function UnAuthedInterceptor($window) {
  return {
    responseError: function(response) {
      if (response.status == 401) {
        $window.location.reload();
      }
      return response;
    }
  };
}
